"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemsContext = void 0;
var react_1 = require("react");
var state_1 = require("./state");
exports.ItemsContext = (0, react_1.createContext)({
    selectedItems: state_1.initialState,
    setState: function () { return undefined; },
});
